import React from 'react';
import { Spinner8 } from 'styled-icons/icomoon';

const Spinner = () => {
  return <Spinner8 className="animate-spin w-4 h-4" />;
};

export default Spinner;
